module.exports = __webpack_public_path__ + "static/john-robbins-veggies-square.8700366e.jpg";